import React, { useState, useLayoutEffect } from 'react';

import { useMediaQuery } from 'react-responsive';

import { PageMenu } from '@ui/moleculs/PageMenu';
import { PageHeader } from '@ui/moleculs/PageHeader';
import { PageBody } from '@ui/moleculs/PageBody';
import { PageFooter } from '@ui/moleculs/PageFooter';

import './App.css';

const { detect } = require('detect-browser');
const browser = detect();


function App() {
  const [hideHeader, setHideHeader] = useState(false);
  const [showBody, setShowBody] = useState(false);
  const [activeMenu, setActiveMenu] = useState(0);
  const [openMenu, setOpenMenu] = useState(true);
  const [isActiveHeader, setActiveHeader] = useState(false);

  const [scrollYPos, setScrollYPos] = useState(0);
  const [scrollDir, setScrollDir] = useState('down');

  useLayoutEffect(() => {
    const threshold = 0;
    let lastScrollY = window.pageYOffset;
    let ticking = false;
  
    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;
      setScrollYPos(scrollY);
      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollDir(scrollY > lastScrollY ? 'down' : 'up');
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const updatePosition = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    }

    window.addEventListener('scroll', updatePosition);
    updatePosition();
    return () => window.removeEventListener('scroll', updatePosition);
  }, []);

  
  const toggleShowBody = () => {
    setShowBody(!showBody);
  };

  const toggleHideHeader = () => {
    setHideHeader(!hideHeader);
  };

  const toggleShowHeader = () => {
    const body = document.querySelector('#root');
    body?.scrollIntoView({
        behavior: 'smooth'
    });
    const timer = setTimeout(() => {
      toggleShowBody();
      clearTimeout(timer);
    }, 1000);
  };

  const toggleActiveMenu = (index: number) => {
    setActiveMenu(index);
  };

  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };

  const toggleActiveHeader = (bool: boolean) => {
    setActiveHeader(bool);
  };

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1024px)'
  });

  return (
    <>
      <PageHeader
        onHidden={toggleHideHeader}
        onClick={toggleShowBody}
        show={showBody}
        isDesktopOrLaptop={isDesktopOrLaptop}
        onToggleMenu={toggleMenu}
        onActiveHeader={toggleActiveHeader}
        open={openMenu}
        browser={browser}
        scrollYPos={scrollYPos}
        scrollDir={scrollDir}
      />
      
      {!isDesktopOrLaptop &&
        <PageMenu
          onShowHeader={toggleShowHeader}
          activeMenu={activeMenu}
          isDesktopOrLaptop={isDesktopOrLaptop}
          onToggleMenu={toggleMenu}
          open={openMenu}
        />
      }

      {showBody ?
        <div
          className={`
            ${isActiveHeader ? `` : `animate-opacity`}
          `}
        >
          <PageBody
            onActiveMenu={toggleActiveMenu}
            onToggleMenu={toggleMenu}
            isDesktopOrLaptop={isDesktopOrLaptop}
            browser={browser}
            scrollYPos={scrollYPos}
            scrollDir={scrollDir}
          />
          {isDesktopOrLaptop &&
            <PageMenu
              onShowHeader={toggleShowHeader}
              activeMenu={activeMenu}
              isDesktopOrLaptop={isDesktopOrLaptop}
              onToggleMenu={toggleMenu}
              open={openMenu}
            />
          }
          <PageFooter />
        </div>
        :
        null
      }
    </>
  );
}

export default App;
